function genGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

const isArray =
    Array.isArray ||
    function (xs) {
        return Object.prototype.toString.call(xs) === '[object Array]';
    };

const isFunction = (fn) => {
    // jquery isFunction
    return typeof fn === 'function' && typeof fn.nodeType !== 'number';
};

function qsParse(qs) {
    const obj = {};

    if (typeof qs !== 'string' || qs.length === 0) {
        return obj;
    }
    qs = qs.split('&');

    for (let i = 0, l = qs.length; i < l; ++i) {
        let x = qs[i].replace(/\+/g, '%20');
        let idx = x.indexOf('=');
        let kstr, vstr, k, v;

        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }

        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);

        if (!hasOwnProperty(obj, k)) {
            obj[k] = v;
        } else if (isArray(obj[k])) {
            obj[k].push(v);
        } else {
            obj[k] = [obj[k], v];
        }
    }

    return obj;
}

function throttle(fun, delay = 500) {
    let last, deferTimer;
    return function (args) {
        let that = this;
        let _args = arguments;
        let now = +new Date();
        if (last && now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(() => {
                last = now;
                fun.apply(that, _args);
            }, delay);
        } else {
            last = now;
            fun.apply(that, _args);
        }
    };
}

function debounce(fun, delay = 500) {
    let timeout;

    return function () {
        timeout && clearTimeout(timeout);

        timeout = setTimeout(() => {
            fun.apply(this, arguments);
            timeout = null;
        }, delay);
    };
}

/**
 * 基于Promise实现的函数防抖功能，可以获取函数执行后的结果
 * @param {function} method 需要防抖的函数
 * @param {number} wait 函数执行的间隔
 * @param {boolean} immediate 函数是否立即执行
 * @returns
 */
function debounceByPromise(method, wait, immediate) {
    let timeout;
    return function (...args) {
        return new Promise((resolve, reject) => {
            let context = this;
            if (timeout) {
                clearTimeout(timeout);
            }
            if (immediate) {
                let callNow = !timeout;
                timeout = setTimeout(() => {
                    timeout = null;
                }, wait);
                if (callNow) {
                    try {
                        const result = method.apply(context, args);
                        resolve(result);
                    } catch (error) {
                        reject(error);
                    }
                }
            } else {
                timeout = setTimeout(() => {
                    try {
                        const result = method.apply(context, args);
                        resolve(result);
                    } catch (error) {
                        reject(error);
                    }
                }, wait);
            }
        });
    };
}

window.__sweet = typeof window.__sweet !== 'undefined' ? window.__sweet : {};
window.__sweet.sweet_create_unique_id_index =
    typeof window.__sweet.sweet_create_unique_id_index !== 'undefined'
        ? window.__sweet.sweet_create_unique_id_index
        : -1;

const createUniqueId = (type = 'id') => {
    ++window.__sweet.sweet_create_unique_id_index;

    const CRC_TAB = ['F', '_', 'E', 'd', 'H', 'o', 'N', 'g', 'V', '5'];
    const byte = `${window.__sweet.sweet_create_unique_id_index}`.split('');
    const res = [];
    for (let i = 0, l = byte.length; i < l; i++) {
        res.push(CRC_TAB[byte[i]]);
    }

    return `${type}_${res.join('_')}`;
};

/**
 * 创建一个只能调用 func 一次的函数。 重复调用返回第一次调用的结果。 func 调用时， this 绑定到创建的函数，并传入对应参数。
 * @param {*} fn
 * @returns
 */
function once(fn) {
    let called = false;
    if (!isFunction(fn)) {
        throw new TypeError('Expected a function');
    }
    return function _once(...args) {
        if (called) {
            return _once.value;
        }
        called = true;
        _once.value = fn.apply(this, args);
    };
}

export {
    once,
    genGuid,
    hasOwnProperty,
    isArray,
    isFunction,
    qsParse,
    throttle,
    debounce,
    createUniqueId,
    debounceByPromise,
};
